import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component'
import { IKeyingDialogData } from '../models/keying-dialog-data.interface'
import { KeyingDialogType } from '../models/keying-dialog-type.enum'

export const showConfirm = (
  dialog: MatDialog,
  dialogType: KeyingDialogType,
  message: string,
  title: string
): MatDialogRef<ConfirmDialogComponent> => {
  const data = getKeyingDialogData(dialogType, message, title)

  return dialog.open(ConfirmDialogComponent, {
    width: '700px',
    data,
  })
}

export const getKeyingDialogData = (
  dialogType: KeyingDialogType,
  message: string,
  title: string
): IKeyingDialogData => {
  if (dialogType === KeyingDialogType.CONFIRM) return getConfirmDialogData(message, title)

  if (dialogType === KeyingDialogType.ALERT) return getAlertDialogData(message, title)

  return null
}

export const getConfirmDialogData = (message: string, title: string): IKeyingDialogData => {
  return {
    title,
    message,
    confirm: KeyingDialogType.CONFIRM,
    cancel: 'Cancel',
    showCancel: true,
    showMessage: true,
  }
}

export const getAlertDialogData = (message: string, title: string): IKeyingDialogData => {
  return {
    title,
    message,
    confirm: KeyingDialogType.ALERT,
    cancel: 'Cancel',
    showCancel: false,
    showMessage: false,
  }
}
